import {
    FacebookButton,
    LinkedInButton,
    TwitterButton,
    RedditButton,
    MailButton,
    LinkButton
} from './buttons.js'

export default function ShareButtons({ url = '', title = '' } = {}) {
    return (
        <ul className="wp-block-social-links" >
            <LinkedInButton url={url} />
            <FacebookButton url={url} />
            <TwitterButton url={url} />
            <RedditButton url={url} />
            <MailButton url={url} subject={title} />
            <LinkButton url={url} />
        </ul>
    )
}